import React from 'react'
import leftColHippie from '../images/welcome-left.png';
import RightColHippie from "../images/welcome-right.png";
import blueStar from '../images/blue-star-mini.png';
import goldStar from '../images/gold-star-mini.png';

function Welcome() {
  return (
    <section className="welcome">
      <div className="left-col">
        <h2>
          Welcome to <br></br>the Hippieverse
        </h2>
        <img src={leftColHippie} alt="hippie" />

        <img src={blueStar} alt="blue star" className="blue-star" />
        <img src={goldStar} alt="gold star" className="gold-star" />
      </div>
      <div className="right-col">
        <p>
          Welcome to the Healing Hippies universe, a Web3 creation fostering
          wellness, unity, and limitless freedom.
        </p>
        <p>
          The Healing Hippies Collection is more than just 4,000 unique digital
          collectibles. It's a journey into our world of captivating content,
          and a community focused on holistic wellness.
        </p>
        <p>
          Experience the Hippieverse, a sanctuary in the digital realm where
          holders connect with wellness experts, promoting growth within a
          supportive community.
        </p>
        <p>
          Join us on this vibrant journey and find your balance in the embrace
          of your new hippie family. Welcome to the Healing Hippies.
        </p>
        <img src={RightColHippie} alt="hippie" />
        
        <img src={goldStar} alt="gold star" className="gold-star" />
        <img src={blueStar} alt="blue star" className="blue-star" />
      </div>
    </section>
  );
}

export default Welcome